import React, { FC } from 'react';

const AppIcon = () => {
  return (
    <svg
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2645 13.0987H2.40737V2.9169H10.2645M10.2645 0.0078125H2.40737C1.53522 0.0078125 0.835938 0.655085 0.835938 1.46236V14.5533C0.835938 14.939 1.0015 15.309 1.2962 15.5818C1.5909 15.8546 1.9906 16.0078 2.40737 16.0078H10.2645C10.6813 16.0078 11.081 15.8546 11.3757 15.5818C11.6704 15.309 11.8359 14.939 11.8359 14.5533V1.46236C11.8359 1.07659 11.6704 0.706619 11.3757 0.433839C11.081 0.161059 10.6813 0.0078125 10.2645 0.0078125Z"
        fill="white"
      />
    </svg>
  );
};

const DetailedHistoryIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.793527 15.0078H15.2578V13.9364H1.32924V0.0078125H0.257812V14.4721L0.793527 15.0078ZM2.40067 12.3292V3.75781L2.93638 3.2221H5.07924L5.61496 3.75781V12.3292L5.07924 12.865H2.93638L2.40067 12.3292ZM4.54353 11.7935V4.29353H3.4721V11.7935H4.54353ZM10.9721 1.61496V12.3292L11.5078 12.865H13.6507L14.1864 12.3292V1.61496L13.6507 1.07924H11.5078L10.9721 1.61496ZM13.115 2.15067V11.7935H12.0435V2.15067H13.115ZM6.68638 12.3292V5.90067L7.2221 5.36496H9.36496L9.90067 5.90067V12.3292L9.36496 12.865H7.2221L6.68638 12.3292ZM8.82924 11.7935V6.43638H7.75781V11.7935H8.82924Z"
        fill="#004B55"
      />
    </svg>
  );
};

const ViabilityIcon = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.674107 14.7321C0.845613 14.9036 1.07823 15 1.32077 15H14.8705C15.1664 15 15.4062 14.7602 15.4062 14.4643C15.4062 14.1684 15.1664 13.9286 14.8705 13.9286H8.44197C4.5957 13.9286 1.47768 10.8106 1.47768 6.96429V0.535715C1.47768 0.239848 1.23783 0 0.941964 0C0.646097 0 0.40625 0.239847 0.40625 0.535714V14.0855C0.40625 14.328 0.502601 14.5606 0.674107 14.7321ZM2.81696 12.5893C2.64546 12.4178 2.54911 12.1852 2.54911 11.9426V4.12881C2.54911 3.88626 2.64546 3.65365 2.81696 3.48214C2.98847 3.31064 3.22108 3.21429 3.46363 3.21429H4.84887C5.09142 3.21429 5.32403 3.31064 5.49554 3.48214C5.66704 3.65365 5.76339 3.88626 5.76339 4.12881V11.9426C5.76339 12.1852 5.66704 12.4178 5.49554 12.5893C5.32403 12.7608 5.09142 12.8571 4.84887 12.8571H3.46363C3.22108 12.8571 2.98847 12.7608 2.81696 12.5893ZM4.15625 11.7857C4.45212 11.7857 4.69196 11.5459 4.69196 11.25V4.82143C4.69196 4.52556 4.45212 4.28571 4.15625 4.28571C3.86038 4.28571 3.62054 4.52556 3.62054 4.82143V11.25C3.62054 11.5459 3.86038 11.7857 4.15625 11.7857ZM11.3884 1.33929C11.2169 1.51079 11.1205 1.7434 11.1205 1.98595V11.9426C11.1205 12.1852 11.2169 12.4178 11.3884 12.5893C11.5599 12.7608 11.7925 12.8571 12.0351 12.8571H13.4203C13.6628 12.8571 13.8955 12.7608 14.067 12.5893C14.2385 12.4178 14.3348 12.1852 14.3348 11.9426V1.98595C14.3348 1.7434 14.2385 1.51079 14.067 1.33929C13.8955 1.16778 13.6628 1.07143 13.4203 1.07143H12.0351C11.7925 1.07143 11.5599 1.16778 11.3884 1.33929ZM12.7277 2.14286C13.0235 2.14286 13.2634 2.3827 13.2634 2.67857V11.25C13.2634 11.5459 13.0235 11.7857 12.7277 11.7857C12.4318 11.7857 12.192 11.5459 12.192 11.25V2.67857C12.192 2.3827 12.4318 2.14286 12.7277 2.14286ZM7.10268 12.5893C6.93117 12.4178 6.83482 12.1852 6.83482 11.9426V6.27166C6.83482 6.02912 6.93117 5.79651 7.10268 5.625C7.27418 5.45349 7.5068 5.35714 7.74934 5.35714H9.13459C9.37713 5.35714 9.60974 5.45349 9.78125 5.625C9.95276 5.79651 10.0491 6.02912 10.0491 6.27166V11.9426C10.0491 12.1852 9.95276 12.4178 9.78125 12.5893C9.60974 12.7608 9.37713 12.8571 9.13459 12.8571H7.74934C7.5068 12.8571 7.27418 12.7608 7.10268 12.5893ZM8.44196 11.7857C8.73783 11.7857 8.97768 11.5459 8.97768 11.25V6.96428C8.97768 6.66842 8.73783 6.42857 8.44196 6.42857C8.1461 6.42857 7.90625 6.66842 7.90625 6.96429V11.25C7.90625 11.5459 8.1461 11.7857 8.44196 11.7857Z"
        fill="#004B55"
      />
    </svg>
  );
};

const SocialTariffIcon = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.21094 11.2078H10.7109V12.8078H4.21094V11.2078ZM4.21094 8.00781H10.7109V9.60781H4.21094V8.00781ZM9.08594 0.0078125H2.58594C1.69219 0.0078125 0.960938 0.727812 0.960938 1.60781V14.4078C0.960938 15.2878 1.68406 16.0078 2.57781 16.0078H12.3359C13.2297 16.0078 13.9609 15.2878 13.9609 14.4078V4.80781L9.08594 0.0078125ZM12.3359 14.4078H2.58594V1.60781H8.27344V5.60781H12.3359V14.4078Z"
        fill="#004B55"
      />
    </svg>
  );
};

interface ICreditCardIconProps {
  color?: string;
}

const CreditCardIcon: FC<ICreditCardIconProps> = ({ color = '#37B482' }) => {
  return (
    <svg
      width="35"
      height="26"
      viewBox="0 0 35 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.945312 4.78161C0.945312 2.45764 2.57339 0.75 4.37826 0.75H30.2603C32.0651 0.75 33.6932 2.45764 33.6932 4.78161V21.2184C33.6932 23.5424 32.0651 25.25 30.2603 25.25H4.37826C2.57339 25.25 0.945312 23.5424 0.945312 21.2184V4.78161Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="0.945312"
        y="5.39307"
        width="32.7479"
        height="4.07143"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="3.59096"
        y="15.5539"
        width="15.7311"
        height="1.39286"
        fill={color}
        stroke={color}
        strokeWidth="1.39286"
      />
      <rect
        x="3.12667"
        y="18.8034"
        width="7.64706"
        height="0.464286"
        stroke={color}
        strokeWidth="0.464286"
      />
      <rect
        x="13.0485"
        y="18.8034"
        width="3.14076"
        height="0.464286"
        stroke={color}
        strokeWidth="0.464286"
      />
    </svg>
  );
};

const CopySuccessIcon = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.375L4.75 8.125L11 1.875"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const TicketCodeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="#AAD7E1" />
      <path
        d="M6 10.5357C6 9.59798 6.36216 8.69866 7.00682 8.03559C7.65148 7.37251 8.52582 7 9.4375 7H10.375C10.6236 7 10.8621 7.10159 11.0379 7.28243C11.2137 7.46327 11.3125 7.70854 11.3125 7.96429C11.3125 8.22003 11.2137 8.4653 11.0379 8.64614C10.8621 8.82698 10.6236 8.92857 10.375 8.92857H9.4375C8.575 8.92857 7.875 9.64857 7.875 10.5357V11.5C7.875 11.7557 7.77623 12.001 7.60041 12.1819C7.4246 12.3627 7.18614 12.4643 6.9375 12.4643C6.68886 12.4643 6.4504 12.3627 6.27459 12.1819C6.09877 12.001 6 11.7557 6 11.5V10.5357ZM20.6875 7.96429C20.6875 7.70854 20.7863 7.46327 20.9621 7.28243C21.1379 7.10159 21.3764 7 21.625 7H22.5625C23.4742 7 24.3485 7.37251 24.9932 8.03559C25.6378 8.69866 26 9.59798 26 10.5357V11.5C26 11.7557 25.9012 12.001 25.7254 12.1819C25.5496 12.3627 25.3111 12.4643 25.0625 12.4643C24.8139 12.4643 24.5754 12.3627 24.3996 12.1819C24.2238 12.001 24.125 11.7557 24.125 11.5V10.5357C24.125 9.64857 23.425 8.92857 22.5625 8.92857H21.625C21.3764 8.92857 21.1379 8.82698 20.9621 8.64614C20.7863 8.4653 20.6875 8.22003 20.6875 7.96429ZM6.9375 19.5357C7.18614 19.5357 7.4246 19.6373 7.60041 19.8181C7.77623 19.999 7.875 20.2443 7.875 20.5V21.4643C7.875 22.3514 8.575 23.0714 9.4375 23.0714H10.375C10.6236 23.0714 10.8621 23.173 11.0379 23.3539C11.2137 23.5347 11.3125 23.78 11.3125 24.0357C11.3125 24.2915 11.2137 24.5367 11.0379 24.7176C10.8621 24.8984 10.6236 25 10.375 25H9.4375C8.52582 25 7.65148 24.6275 7.00682 23.9644C6.36216 23.3013 6 22.402 6 21.4643V20.5C6 20.2443 6.09877 19.999 6.27459 19.8181C6.4504 19.6373 6.68886 19.5357 6.9375 19.5357ZM25.0625 19.5357C25.3111 19.5357 25.5496 19.6373 25.7254 19.8181C25.9012 19.999 26 20.2443 26 20.5V21.4643C26 22.402 25.6378 23.3013 24.9932 23.9644C24.3485 24.6275 23.4742 25 22.5625 25H21.625C21.3764 25 21.1379 24.8984 20.9621 24.7176C20.7863 24.5367 20.6875 24.2915 20.6875 24.0357C20.6875 23.78 20.7863 23.5347 20.9621 23.3539C21.1379 23.173 21.3764 23.0714 21.625 23.0714H22.5625C23.425 23.0714 24.125 22.3514 24.125 21.4643V20.5C24.125 20.2443 24.2238 19.999 24.3996 19.8181C24.5754 19.6373 24.8139 19.5357 25.0625 19.5357ZM10.375 10.8571C10.6236 10.8571 10.8621 10.9587 11.0379 11.1396C11.2137 11.3204 11.3125 11.5657 11.3125 11.8214V20.1786C11.3125 20.4343 11.2137 20.6796 11.0379 20.8604C10.8621 21.0413 10.6236 21.1429 10.375 21.1429C10.1264 21.1429 9.8879 21.0413 9.71209 20.8604C9.53627 20.6796 9.4375 20.4343 9.4375 20.1786V11.8214C9.4375 11.5657 9.53627 11.3204 9.71209 11.1396C9.8879 10.9587 10.1264 10.8571 10.375 10.8571ZM15.0625 11.8214C15.0625 11.5657 14.9637 11.3204 14.7879 11.1396C14.6121 10.9587 14.3736 10.8571 14.125 10.8571C13.8764 10.8571 13.6379 10.9587 13.4621 11.1396C13.2863 11.3204 13.1875 11.5657 13.1875 11.8214V20.1786C13.1875 20.4343 13.2863 20.6796 13.4621 20.8604C13.6379 21.0413 13.8764 21.1429 14.125 21.1429C14.3736 21.1429 14.6121 21.0413 14.7879 20.8604C14.9637 20.6796 15.0625 20.4343 15.0625 20.1786V11.8214ZM17.875 10.8571C18.1236 10.8571 18.3621 10.9587 18.5379 11.1396C18.7137 11.3204 18.8125 11.5657 18.8125 11.8214V20.1786C18.8125 20.4343 18.7137 20.6796 18.5379 20.8604C18.3621 21.0413 18.1236 21.1429 17.875 21.1429C17.6264 21.1429 17.3879 21.0413 17.2121 20.8604C17.0363 20.6796 16.9375 20.4343 16.9375 20.1786V11.8214C16.9375 11.5657 17.0363 11.3204 17.2121 11.1396C17.3879 10.9587 17.6264 10.8571 17.875 10.8571ZM22.5625 11.8214C22.5625 11.5657 22.4637 11.3204 22.2879 11.1396C22.1121 10.9587 21.8736 10.8571 21.625 10.8571C21.3764 10.8571 21.1379 10.9587 20.9621 11.1396C20.7863 11.3204 20.6875 11.5657 20.6875 11.8214V20.1786C20.6875 20.4343 20.7863 20.6796 20.9621 20.8604C21.1379 21.0413 21.3764 21.1429 21.625 21.1429C21.8736 21.1429 22.1121 21.0413 22.2879 20.8604C22.4637 20.6796 22.5625 20.4343 22.5625 20.1786V11.8214Z"
        fill="#004B55"
      />
    </svg>
  );
};

const PixCodeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="#FFD79B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1154 10.6209C14.9143 9.10294 17.0878 9.10295 17.8867 10.6209L22.5039 19.3936C23.2507 20.8126 22.2218 22.5169 20.6182 22.5169H11.3838C9.78028 22.5169 8.7513 20.8126 9.49813 19.3936L14.1154 10.6209ZM16.5593 11.3195C16.3228 10.8701 15.6793 10.8701 15.4427 11.3195L10.8255 20.0922C10.6044 20.5123 10.909 21.0169 11.3838 21.0169H20.6182C21.093 21.0169 21.3977 20.5123 21.1765 20.0922L16.5593 11.3195ZM16.001 12.7315C16.4152 12.7315 16.751 13.0673 16.751 13.4815V16.9338C16.751 17.348 16.4152 17.6838 16.001 17.6838C15.5868 17.6838 15.251 17.348 15.251 16.9338V13.4815C15.251 13.0673 15.5868 12.7315 16.001 12.7315ZM14.9058 19.0051C14.9058 18.4003 15.3961 17.9099 16.001 17.9099C16.6059 17.9099 17.0962 18.4003 17.0962 19.0051C17.0962 19.61 16.6059 20.1004 16.001 20.1004C15.3961 20.1004 14.9058 19.61 14.9058 19.0051Z"
        fill="#212529"
      />
    </svg>
  );
};

const DownloadIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 10L5.5 7M9 10L12.5 7M9 10L9 5.5L9 0.999999"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 14L1.96575 15.8638C2.04686 16.1883 2.23412 16.4763 2.49775 16.6822C2.76138 16.8881 3.08626 16.9999 3.42075 17H14.5792C14.9137 16.9999 15.2386 16.8881 15.5023 16.6822C15.7659 16.4763 15.9531 16.1883 16.0343 15.8638L16.5 14"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export {
  AppIcon,
  DetailedHistoryIcon,
  ViabilityIcon,
  SocialTariffIcon,
  CreditCardIcon,
  CopySuccessIcon,
  TicketCodeIcon,
  PixCodeIcon,
  DownloadIcon,
};
